import {
  createSlice,
  createAsyncThunk,
  createEntityAdapter,
  PayloadAction,
} from "@reduxjs/toolkit";
import { getSecretResourcesRequest } from "./secretsApiService";
import { RootState } from "@app/store";
import { SecretResource } from "./types";

const secretResourcesAdapter = createEntityAdapter<SecretResource>({
  selectId: (secretResource) => secretResource.resource_guid,
});

const initialState = secretResourcesAdapter.getInitialState({
  status: "",
  selectedResource: "",
});

const secretResourcesSlice = createSlice({
  name: "secretResources",
  initialState,
  reducers: {
    selectSecretResource(state, action: PayloadAction<string>) {
      state.selectedResource = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSecretResources.pending, (state) => {
        state.status = "loading";
      })
      .addCase(
        fetchSecretResources.fulfilled,
        (state, { payload }: PayloadAction<SecretResource[]>) => {
          secretResourcesAdapter.setAll(state, payload);
          state.status = "";
        },
      )
      .addCase(fetchSecretResources.rejected, (state) => {
        state.status = "";
      });
  },
});

export const fetchSecretResources = createAsyncThunk(
  "secretResources/fetchSecretResources",
  async (customerId: string) => {
    try {
      const res = await getSecretResourcesRequest(customerId);
      if (res) return res.data;
      else return res;
    } catch (err) {
      console.error(err);
      throw new Error("failed to fetch secret resources data");
    }
  },
);

export const { selectSecretResource } = secretResourcesSlice.actions;
export default secretResourcesSlice.reducer;

const secretResourcesSelectors = secretResourcesAdapter.getSelectors(
  (state: RootState) => state.secretResources,
);

export const getSecretResources = (state: RootState) => {
  return secretResourcesSelectors.selectAll(state);
};

export const getSelectedSecretResource = (state: RootState) => {
  return state.secretResources.selectedResource;
};
